module.exports = __webpack_public_path__ + "static/img/feeler.17e7be0f.jpg";